import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-formgtm', observe: true })
export class FormGTMComponent {

	constructor(private element: HTMLSelectElement) {
        let tagName = this.element.getAttribute("data-formgtm");
        // Take this.element as form if its a form, else take closest parent, else take first child
        let form = this.element.tagName == 'form' ? this.element : this.element.closest('form') ?? this.element.querySelector('form'); 

        form?.setAttribute("data-formgtm", tagName);

        form?.addEventListener('change', () => {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': `form_change_start`,
                'name': tagName
            });
            //^(.*)\_start$
        }, { once: true });
	}
}